import { createAppContainer } from 'react-navigation';
import { createStackNavigator } from 'react-navigation-stack';
import { createBrowserApp } from '@react-navigation/web';
import { Platform } from 'react-native';
import HomeScreen from './src/screens/HomeScreen';
import VariableScreen from './src/screens/VariableScreen';
import FluidViscosityDetailsScreen from './src/screens/FluidViscosityDetailsScreen';



const createApp = Platform.select({
  web: config => createBrowserApp(config, {history: 'hash' }),
  default: config => createAppContainer(config)
});

export default createApp(
  createStackNavigator(
    {
      Home: HomeScreen,
      Variable: VariableScreen,
      ViscosityDetails: FluidViscosityDetailsScreen,
    },
    {
      initialRouteName: 'Home',
      defaultNavigationOptions: {
        title: 'BP Supply Production Calculator',
      },
    }
  )
);
